import { client } from '../apiClient';
import { AgencyStatsResponse } from '../../models/agency-stats/AgencyStatsResponse';

const ENDPOINT = '/agency-stats';

export const getAgencyStats = async (from: Date, to: Date): Promise<AgencyStatsResponse> => {
  return client(true, true)
    .get<AgencyStatsResponse>(ENDPOINT, {
      params: {
        from: from.toISOString(),
        to: to.toISOString(),
      },
    })
    .then((response) => response.data)
    .catch((error) => error);
};
